<div class="hero-section">
    <app-menu-bar></app-menu-bar>
    <div class="overlay-content">
        <span class="title">{{ 'about_hero_title' | translate }}</span>
        <span class="subtitle">{{ 'about_hero_subtitle' | translate }}</span>
    </div>
</div>

<!-- The story runs far longer than the photo is tall, so the photo and a
     four-step index stay pinned while the text scrolls past them, and the
     index marks the chapter being read. -->
<section class="story-section">
    <aside class="media">
        <div class="light-frame story-frame">
            <img src="assets/images/homepage/about-us.jpg" alt="FYES" class="story-img">
            @for (light of storyLights; track $index) {
            <span class="light" [attr.data-kind]="light.kind" aria-hidden="true"
                [style.--x]="light.x" [style.--y]="light.y"
                [style.animation-delay.s]="light.delay" [style.animation-duration.s]="light.duration"></span>
            }
        </div>

        <ol class="index">
            @for (chapter of chapters; track chapter.year; let i = $index) {
            <li [class.active]="i === activeChapter">
                <button type="button" (click)="goToChapter(i)">
                    <span class="year">{{ chapter.year | translate }}</span>
                    <span class="name">{{ chapter.title | translate }}</span>
                </button>
            </li>
            }
        </ol>
    </aside>

    <div class="copy">
        <span class="title">{{ 'about_s1_title' | translate }}</span>

        @for (chapter of chapters; track chapter.year; let i = $index) {
        <div class="chapter" #chapterEl>
            <span class="eyebrow">{{ chapter.year | translate }} · {{ chapter.title | translate }}</span>
            @if (i === 0) {
            <p class="lead">{{ 'about_s1_p1' | translate }}</p>
            }
            @for (key of chapter.paragraphs; track key) {
            <p>{{ key | translate }}</p>
            }
        </div>
        }
    </div>
</section>

<section class="technology-section">
    <div class="left">
        <span class="title">{{ 'about_s2_title' | translate }}</span>
        <span class="description">{{ 'about_s2_text' | translate }}</span>
    </div>
    <div class="right">
        <div class="light-frame tech-frame">
            <img src="assets/images/homepage/about-technology.webp" alt="FYES facility" class="tech-img">
            @for (light of techLights; track $index) {
            <span class="light" [attr.data-kind]="light.kind" aria-hidden="true"
                [style.--x]="light.x" [style.--y]="light.y"
                [style.animation-delay.s]="light.delay" [style.animation-duration.s]="light.duration"></span>
            }
        </div>
    </div>
</section>

<section class="values-section">
    <div class="left">
        <div class="light-frame partners-frame">
            <img src="assets/images/homepage/about-partners.webp" alt="FYES partners" class="values-img">
            @for (light of partnerLights; track $index) {
            <span class="light" [attr.data-kind]="light.kind" aria-hidden="true"
                [style.--x]="light.x" [style.--y]="light.y"
                [style.animation-delay.s]="light.delay" [style.animation-duration.s]="light.duration"></span>
            }
        </div>
    </div>
    <div class="right">
        <span class="title">{{ 'about_s3_title' | translate }}</span>
        <div class="description">
            <p>{{ 'about_s3_p1' | translate }}</p>
            <p>{{ 'about_s3_p2' | translate }}</p>
            <p>{{ 'about_s3_p3' | translate }}</p>
        </div>
    </div>
</section>

<section class="final-section">
    <div class="banner">
        <span class="title">{{ 'about_final_title' | translate }}</span>
        <span class="description">{{ 'about_final_description' | translate }}</span>
        <div class="button-area">
            <button class="primary-btn" (click)="goToUrl('journey')">{{ 'about_final_cta' | translate }}</button>
            <span class="text">{{ 'about_final_questions' | translate }} <span class="highlight" (click)="goToUrl('contact')">{{ 'cta_contact_us' | translate }}</span></span>
        </div>
    </div>
</section>

<app-footer></app-footer>
